const labels = () => ({
	default: "en",
	icon: {
		arrowleft: "←",
		arrowright: "→",
		attach: "📄",
		back: "◀︎",
		cancel: "↖︎",
		close: "✕",
		create: "✚",
		delete: "✕",
		edit: "📝",
		down: "▼",
		"down-alt": "▽",
		forward: "▶︎",
		injection: "🩼",
		lock: "🔓",
		network: "⇄",
		ok: "✔︎",
		pause: "||",
		reload: "↺",
		stop: "◼︎",
		trash: "🗑️",
		up: "▲",
		"up-alt": "△",
		users: "\uD83D\uDC65",
		wheel: "⚙️"
	},
	it: {
		"1 column out of 2": "Una colonna su 2",
		"1 column out of 3": "Una colonna su 3",
		"2 columns out of 3": "Due colonne su 3",
		"Add": "Aggiungi",
		"Add after…": "Aggiungi dopo…",
		"Administrator": "Amministratore",
		"All": "Tutti",
		"Admin panel": "Pannello di amministrazione",
		"ATECO codes": "Elenco codici ATECO",
		"ATECO entries": "Codici ATECO",
		"AtLeastLenChars": "Sono richiesti almeno {{len|alcuni}} caratteri",
		"Authenticating…":"Autenticazione in corso…",
		"Authentication is mandatory":"È necessario autenticarsi",
		"Available items": "Item presenti",
		"Browse": "Naviga",
		"Cancel": "Annulla",
		"Changes": "Modifiche",
		"Collapse all": "Chiudi tutti",
		"Confirm password": "Conferma password",
		"ConfirmPasswordIf": "Conferma la password (se cambiata)",
		"ConfirmItemDeletion": "Confermi la cancellazione di {{item|questo item}}?",
		"ConfirmUserDeletion": "Confermi la cancellazione di questo utente?",
		"Days":"Giorni",
		"DependOnItem": "Dipendono da {{item|questo}}",
		"Depends": "Dipende da",
		"Disabled user": "Utente disabilitato",
		"Duplicated":"Duplicato",
		"Edit": "Modifica",
		"Edit Form": "Modifica Form",
		"Edit group": "Modifica gruppo",
		"Edit user": "Modifica utente",
		"Edit own user": "Modifica del proprio utente",
		"Empty":"Vuoto",
		"EmptyAutoVale":"Lascia vuoto per un valore automatico",
		"Exit": "Esci",
		"Expand all": "Espandi tutti",
		"Field": "Campo",
		"Fields": "Campi",
		"Fields group (with subnode)":"Gruppo di campi (con sottonodo)",
		"Form definition": "Definizione del form",
		"formIsEmpty": "il form non è stato definito",
		"FormIsEmpty": "Il form non è stato definito",
		"Forgot password":"Password nuova o dimenticata",
		"Full width": "Larghezza piena",
		"Group": "Gruppo",
		"Group already exists": "Gruppo già presente",
		"Group ID is mandatory": "L’ID del gruppo è obbligatorio",
		"GroupCantRemove": "Un gruppo può essere eliminato solo se non ha utenti",
		"GroupDescOptional": "Descrizione del gruppo (facoltativa)",
		"GroupIdMandatory": "ID del gruppo (obbligatorio)",
		"GroupIdMinLen": "L’ID del gruppo richiede almeno {{len|5}} caratteri",
		"GroupRemove": "Elimina definitivamente il gruppo",
		"Groups": "Gruppi",
		"Hours":"Ore",
		"If": "Se",
		"Indent": "Indentato",
		"Items": "Item",
		"Items can be changed": "Gli item possono essere modificati",
		"Items can be created": "Gli item possono essere creati",
		"Last edit":"Ultima modifica",
		"Last warning":"Ultimo avviso",
		"lastUpdate": "ultimo aggiornamento {{date|sconosciuto}}",
		"LastUpdate": "Ultimo aggiornamento {{date|sconosciuto}}",
		"Loading…": "Caricamento…",
		"Lock": "Blocca",
		"Main menu": "Menu principale",
		"MainMenuIntro": "Scelta attività",
		"Mandatory field": "Campo obbligatorio",
		"Mismatch":"Non coincide",
		"Move to bottom": "Sposta in fondo",
		"Move to top": "Sposta in cima",
		"members": "membri",
		"Minutes":"Minuti",
		"Multiple":"Multiplo",
		"Multiple fields always return an array":"I campi multipli tornano sempre un array di valori",
		"Name": "Nome",
		"New group": "Nuovo gruppo",
		"New item": "Nuovo item",
		"New password": "Nuova password",
		"No change":"Nessun cambiamento",
		"No group": "Nessun gruppo",
		"Not empty": "Non vuoto",
		"New user": "Nuovo utente",
		"No users in this group": "Nessun utente in questo gruppo",
		"Node ID": "ID nodo",
		"NoItemsFound": "Ancora nessun item presente",
		"Only alphanumeric charaters allowed": "Sono ammessi solo caratteri alfanumerici",
		"OptionalPasswordChange": "Opzionale: cambio password",
		"Password change":"Cambio password",
		"Passwords don't match": "Le password non coincidono",
		"Record changes": "Salva le modifiche",
		"Remove": "Elimina",
		"Rename":"Rinomina",
		"Revert": "Ripristina",
		"Save": "Salva",
		"Select": "Seleziona",
		"SelectMulti": "Seleziona…",
		"SelectMultiNote": "Permetti scelte multiple, il valore sarà sempre un array",
		"Set password":"Imposta la password",
		"Settings": "Impostazioni",
		"Short": "Breve",
		"Show": "Mostra",
		"System login":"Accesso al sistema",
		"Then": "Allora",
		"This field is mandatory": "Questo campo è obbligatorio",
		"TokenWasSent":"Se nome utente o mail erano validi, controlla la mail (anche lo spam)",
		"Unique login": "Login univoca",
		"User already exists": "Utente già presente",
		"UserEmailDesc": "Email (opzionale)",
		"UserIsAdminDesc": "★️ È un amministratore",
		"UserIsDisabledDesc": "✘ L’utente è disabilitato",
		"UserNameDesc": "Nome visualizzato (opzionale)",
		"UsernameOrEmail":"Nome utente o mail registrata",
		"User name":"Nome utente",
		"Users": "Utenti",
		"Verify":"Verifica",
		"View": "Vista",
		"View as slider": "Visualizza come slider",
		"Yes":"Sì",
		"When":"Quando",
	},
	en: {
		"Admin panel": "Administration panel",
		"AtLeastLenChars": "At least {{len|some}} characters are required",
		"ConfirmPasswordIf": "Confirm password (if changed)",
		"ConfirmItemDeletion": "Are you sure that you want to remove {{item|this item}}?",
		"ConfirmUserDeletion": "Are you sure that you want to remove this user?",
		"DependOnItem": "Depend on {{item|thhis item}}",
		"EmptyAutoVale":"Leave empty for auto-generated value",
		"Forgot password":"New or forgot password",
		"formIsEmpty": "form is undefined",
		"FormIsEmpty": "Form is undefined",
		"GroupCantRemove": "Only empty groups can be deleted",
		"GroupDescOptional": "Group description (optional)",
		"GroupIdMandatory": "Group ID (mandatory)",
		"GroupIdMinLen": "Group ID must be at least {{len|5}} characters long",
		"GroupRemove": "Definitely remove this group",
		"lastUpdate": "last updated on {{date|unknown date}}",
		"LastUpdate": "Last updated on {{date|unknown date}}",
		"MainMenuIntro": "Choose activity",
		"NoItemsFound": "There are no items yet",
		"OptionalPasswordChange": "Optional: password change",
		"SelectMulti": "Select…",
		"SelectMultiNote": "Multiple choices allowed, value is always an array",
		"TokenWasSent":"If user/mail where valid, check your mailbox (check also for spam)",
		"UserEmailDesc": "Email (optional)",
		"UsernameOrEmail":"User name or registered e-mail",
		"UserIsAdminDesc": "★️ User is an administrator",
		"UserIsDisabledDesc": "✘ User is disabled",
		"UserNameDesc": "Public name (optional)"
	}
});

export default labels;
